import { AzzurroHubDataType, ConnextData } from "ngx-core-services";
import { SystemDefinition } from "../../state/system.state";

export const checkAndUpdateConnectionSystemStatus = (system: SystemDefinition): SystemDefinition => {
  if (system.monitoringType === 'Connext') {
    return checkAndUpdateConnextSystemStatus(system);
  }

  if (system.monitoringType === 'AzzurroHub') {
    return checkAndUpdateAzzurroHubSystemStatus(system);
  }

  return system;
}

export const checkAndUpdateConnextSystemStatus = (system: SystemDefinition): SystemDefinition =>{
  const connextData = system.data as Partial<ConnextData>;
  const isConnected = connextData?.info?.connection.status === 'connected';

  return {
    ...system,
    metadata: {
      /** Default to Europe/Rome */
      ...system.metadata,
      tz: system.metadata?.tz ?? 2,
      structure: system.metadata?.structure ?? 2,
      isConnected,
    },
  };
}

export const checkAndUpdateAzzurroHubSystemStatus = (system: SystemDefinition): SystemDefinition => {
  const azzurroHubData = system.data as Partial<AzzurroHubDataType>;
  const isConnected = azzurroHubData.info?.connection?.status === 'connected';

  return {
    ...system,
    metadata: {
      /** Default to Europe/Rome */
      ...system.metadata,
      tz: system.metadata?.tz ?? 2,
      structure: system.metadata?.structure ?? 2,
      isConnected,
    },
  };
}
